import React from "react";
import styles from "./ChatHandlePane.module.scss";
export function ChatHandlePane(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, !props.isStreaming ? /*#__PURE__*/React.createElement("div", {
    className: styles.handleButton,
    onClick: function onClick() {
      return props.onRegenerateClicked();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.handleImage
  }, /*#__PURE__*/React.createElement(ChatHandleRegenerate, null)), /*#__PURE__*/React.createElement("span", {
    className: styles.handleText
  }, "Regenerate")) : null, props.isStreaming ? /*#__PURE__*/React.createElement("div", {
    className: styles.handleButton,
    onClick: function onClick() {
      return props.onStopGenerateClicked();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.handleImage
  }, /*#__PURE__*/React.createElement(ChatHandleStartNew, null)), /*#__PURE__*/React.createElement("span", {
    className: styles.handleText
  }, "Stop Generating")) : null);
}

/// Regenerate 图标
function ChatHandleRegenerate() {
  // 👇️ 将 SVG 粘贴到组件中
  // 将 fill 和 stroke 颜色作为属性
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2169_43313)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20",
    rx: "10",
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#020C26",
    fillOpacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00488 8.88889C5.00488 8.88889 6.11876 7.37123 7.02368 6.46569C7.9286 5.56015 9.1791 5 10.5604 5C13.3219 5 15.5604 7.23858 15.5604 10C15.5604 12.7614 13.3219 15 10.5604 15C9.43461 15 8.3957 14.6279 7.55995 14M5.00488 8.88889V5.55556M5.00488 8.88889H8.33822",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2169_43313",
    x: "-40",
    y: "-40",
    width: "100",
    height: "100",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: "20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2169_43313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2169_43313",
    result: "shape"
  }))));
}

/// StartNew 图标
function ChatHandleStartNew() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2169_43288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20",
    rx: "10",
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#020C26",
    fillOpacity: "0.1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "8",
    height: "8",
    rx: "1.5",
    transform: "matrix(-1 0 0 1 14 6)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2169_43288",
    x: "-40",
    y: "-40",
    width: "100",
    height: "100",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: "20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2169_43288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2169_43288",
    result: "shape"
  }))));
}